import { parseCustomDate } from '@/helpers/dateUtils'
import type { SearchResult } from '@/queries/listingSearchQuery'

export const getEndTime = (listing: SearchResult): Date => {
  const parsedBuyNowEndTime =
    listing.buyNow && listing.buyNowEndTime
      ? parseCustomDate(listing.buyNowEndTime)
      : null

  if (parsedBuyNowEndTime && parsedBuyNowEndTime > new Date()) {
    return parsedBuyNowEndTime
  }

  return parseCustomDate(
    listing.auctionEnt?.endTime ??
      listing.auction3MP?.actualEndTime ??
      listing.endTime
  )
}
